import PillarForm from "shared/components/pillar-form/PillarForm";

export const HubCheckoutAddressForm = ({
  addressType,
}: {
  addressType: string;
}) => {
  return (
    <>
      <h4 className="text-subheader">{addressType} Address</h4>
      <div>
        <PillarForm.TextInput
          testid={`hub-checkout-${addressType}-address-input`}
          additionalClasses="w-full rounded-md "
          name={`${addressType.toLowerCase()}AddressData.line1`}
          label="Address"
          placeholder="Enter Address"
        />
      </div>
      <div className="grid grid-cols-3 gap-2 pt-2">
        <div className="pt-1">
          <PillarForm.TextInput
            testid={`hub-checkout-${addressType}-city-input`}
            additionalClasses="rounded-md"
            name={`${addressType.toLowerCase()}AddressData.city`}
            label="City"
            placeholder="Enter City"
          />
        </div>
        <div className="pt-1 ">
          <PillarForm.TextInput
            testid={`hub-checkout-${addressType}-state-input`}
            additionalClasses="rounded-md "
            name={`${addressType.toLowerCase()}AddressData.state`}
            label="State"
            placeholder="Enter State"
          />
        </div>
        <div className="pt-1 ">
          <PillarForm.TextInput
            testid={`hub-checkout-${addressType}-zipcode-input`}
            additionalClasses="rounded-md "
            name={`${addressType.toLowerCase()}AddressData.postalCode`}
            label="Zip"
            placeholder="Zip Code"
          />
        </div>
      </div>
      <div>
        <PillarForm.TextInput
          testid={`hub-checkout-${addressType}-country-input`}
          additionalClasses="w-full rounded-md "
          name={`${addressType.toLowerCase()}AddressData.country`}
          label="Country"
          placeholder="Enter Country"
        />
      </div>
    </>
  );
};
